/* ============================================================
   PB: Info Drawers – open/close logic + mobile drag-scroll
   ============================================================ */
(function () {
  'use strict';

  /* ── Drawer logic ── */
  function openDrawer(drawer) {
    drawer.removeAttribute('hidden');
    drawer.classList.add('is-animating');

    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        drawer.classList.add('is-open');
        document.body.style.overflow = 'hidden';

        var close = drawer.querySelector('.pb-info-drawer__close');
        if (close) close.focus();
      });
    });
  }

  function closeDrawer(drawer) {
    drawer.classList.remove('is-open');
    document.body.style.overflow = '';

    drawer.addEventListener('transitionend', function handler(e) {
      if (e.target !== drawer.querySelector('.pb-info-drawer__panel')) return;
      drawer.classList.remove('is-animating');
      drawer.setAttribute('hidden', '');
      drawer.removeEventListener('transitionend', handler);
    });
  }

  function initTriggers(root, drawerIds) {
    /* Triggers nằm trong root */
    root.querySelectorAll('.pb-info-drawers__trigger').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var drawerId = btn.getAttribute('aria-controls');
        var drawer = document.getElementById(drawerId);
        if (!drawer) return;
        btn.setAttribute('aria-expanded', 'true');
        openDrawer(drawer);
      });
    });

    /* Drawers đã được portal ra body — query bằng ID */
    drawerIds.forEach(function (drawerId) {
      var drawer = document.getElementById(drawerId);
      if (!drawer) return;

      var overlay = drawer.querySelector('.pb-info-drawer__overlay');
      var closeBtn = drawer.querySelector('.pb-info-drawer__close');

      function close() {
        closeDrawer(drawer);
        var trigger = root.querySelector('[aria-controls="' + drawerId + '"]');
        if (trigger) {
          trigger.setAttribute('aria-expanded', 'false');
          trigger.focus();
        }
      }

      if (overlay) overlay.addEventListener('click', close);
      if (closeBtn) closeBtn.addEventListener('click', close);

      drawer.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') close();
      });
    });
  }

  /* ── Mobile drag-to-scroll ── */
  function initDragScroll(list) {
    var isDown = false;
    var startX = 0;
    var scrollLeft = 0;

    list.addEventListener('mousedown', function (e) {
      isDown = true;
      list.classList.add('is-dragging');
      startX = e.pageX - list.offsetLeft;
      scrollLeft = list.scrollLeft;
      e.preventDefault();
    });

    document.addEventListener('mouseup', function () {
      isDown = false;
      list.classList.remove('is-dragging');
    });

    list.addEventListener('mousemove', function (e) {
      if (!isDown) return;
      var x = e.pageX - list.offsetLeft;
      list.scrollLeft = scrollLeft - (x - startX);
    });
  }

  /* ── Portal: move drawers to <body>, return their IDs ── */
  function portalDrawers(root) {
    var ids = [];
    root.querySelectorAll('.pb-info-drawer').forEach(function (drawer) {
      ids.push(drawer.id);
      document.body.appendChild(drawer);
    });
    return ids;
  }

  /* ── Init ── */
  function init() {
    document.querySelectorAll('.pb-info-drawers').forEach(function (root) {
      var drawerIds = portalDrawers(root);
      initTriggers(root, drawerIds);
      var list = root.querySelector('.pb-info-drawers__list');
      if (list) initDragScroll(list);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
